import { lazy } from "react";

const ContactMonitoringHome = lazy(() => import("./ContactMonitoringHome.js"));

const routes = [
  {
    path: "/dashboard/contact-monitoring",
    exact: true,
    name: "Monitoreo de Equipo de Contacto",
    component: ContactMonitoringHome
  }
];

export default routes;
